export const page1 = {
  name: 'page1',
  title: 'Privacy Policy',
  questions: [
    {
      "type": "boolean",
      "name": "privacyPolicy",
      "title": "To be able to provide you with advice from our experts, we need your consent to process your data. For more information, read our Privacy Policy.\n\nDo you accept the Privacy Policy?",
      "isRequired": true,
      "swapOrder": true
    }
  ]
};